// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vAj-","title":"styles_title__I5cse"};